/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate, useParams } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
// material
import CommonPageHeader from '../../CommonPageModules/CommonPageHeader';
import { Stack, TextField, IconButton, InputAdornment } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import MenuItem from '@material-ui/core/MenuItem';
import locationServices from '../../../commonServices/LocationServices';
import userServices from '../../../commonServices/UserServices';
import services from './Service'
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AESDecryptionParam } from '../../../helpers/AesEncrypt';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

// ----------------------------------------------------------------------

export default function RegisterForm(props) {
  const screenCode = 'USER';
  const navigate = useNavigate();
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [district, setDistrict] = useState([]);
  const [city, setCity] = useState([]);
  const [roles, setRoles] = useState([]);
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Register",
    pageheadername: "Add User"
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const { userID } = useParams();
  const [formData, setFormData] = useState({
    groupID: 0,
    factoryID: 0,
    userTypeID: 0,
    roleID: "",
    userName: "",
    firstName: "",
    secondName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    nIC: "",
    address1: "",
    address2: "",
    mobileNumber: "",
    landNumber: "",
    province: 0,
    district: 0,
    city: 0,
    isLock: false,
    isActive: true

  });
  const phoneRegExp = /^0?[1-9]\d{8}$/
  const RegisterSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please select a group').required('Group Required'),
    factoryID: Yup.number().min(1, 'Please select a operation entity').required('Operation Entity Required'),
    userTypeID: Yup.number(0, 'Please select a user Type').required('User Required'),
    roleID: Yup.number().min(1, 'Please select a role').required('Role Required'),
    userName: Yup.string().matches(/^[a-zA-Z0-9]+$/, 'Please enter only alphanumeric characters')
      .min(5, 'Username must be at least 5 characters')
      .max(10, 'Username must not exceed 10 characters')
      .required('Username is required'),
    firstName: Yup.string().required('First name required'),
    secondName: Yup.string().required('Second name required'),
    lastName: Yup.string().notRequired(),
    confirmPassword: pageProps.isEdit ? (Yup.string().notRequired()) : (Yup.string().required('Confirm Password required')),
    nIC: Yup.string().notRequired().matches(/^(\d{9}[vVxX]|\d{12})$/, 'Entered NIC not valid'),
    address1: Yup.string().notRequired(),
    address2: Yup.string().notRequired(),
    mobileNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Mobile Number Required'),
    landNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').notRequired(),
    province: Yup.number().min(1, 'Please select a province').required('Province Required'),
    district: Yup.number().min(1, 'Please select a district').required('District Required'),
    city: Yup.number().min(1, 'Please select a city').required('City Required'),
    password: pageProps.isEdit ? (Yup.string().notRequired().min(8, 'minimum 8 digits required'))
      : (Yup.string().min(8, 'Password must be at least 8 characters long')
        .max(20, 'Password must not exceed 20 characters')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]+$/,
          'Password must include capital letters, simple letters, symbols, and numbers'
        )
        .required('Password is required'))
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      factoryID: formData.factoryID,
      userTypeID: formData.userTypeID,
      roleID: formData.roleID,
      userName: formData.userName,
      firstName: formData.firstName,
      secondName: formData.secondName,
      lastName: formData.lastName,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      nIC: formData.nIC,
      address1: formData.address1,
      address2: formData.address2,
      mobileNumber: formData.mobileNumber,
      landNumber: formData.landNumber,
      province: formData.province,
      district: formData.district,
      city: formData.city,
      isLock: formData.isLock,
      isActive: formData.isActive,
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit) {
        trackPromise(UpdateUser(values))
      } else {
        trackPromise(SaveUser(values));
      }

    },
  });

  const handleKeyDown = (e) => {
    if (e.key === " " && name.length === 0) {
      e.preventDefault();
    }
  };

  async function SaveUser(values) {
    if (values.password === values.confirmPassword) {
      var res = await services.SaveUser(values);
      if (res.statusCode === "Success") {
        toast.success("User Saved Succesfully");
        setTimeout(() => {
          navigate('/dashboard/user/');
        }, 3000);

      } else {
        toast.error(res.message);

      }
    } else {
      toast.error("Password Mismatch!");
    }
  }
  async function UpdateUser(values) {
    var res = await services.UpdateUser(values, pageProps.editingID);
    if (res.statusCode === "Success") {
      toast.success("User Updated Succesfully");
      setTimeout(() => {
        navigate('/dashboard/user/');
      }, 3000);

    } else {
      toast.error(res.message);
    }

  }
  let decrypted = 0;

  useEffect(() => {
    decrypted = AESDecryptionParam(userID.toString());
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        editingID: parseInt(decrypted),
        pageheadername: "Edit User"
      })
    }
  }, []);

  useEffect(() => {

    if (pageProps.editingID > '0') {
      trackPromise(setForEdit(pageProps.editingID))
    }

  }, [pageProps.editingID]);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    let provinceID = formik.values.province;
    if (provinceID != 0) {
      getDistrictFromProvince(provinceID);
    }
  }, [formik.values.province]);

  useEffect(() => {
    let provinceID = formik.values.province;
    let districtID = formik.values.district;
    if (districtID != 0) {
      getCitiesFromFilter(provinceID, districtID);
    }
  }, [formik.values.district]);

  useEffect(() => {
    GetFactoriesByGroupID();
  }, [formik.values.groupID]);

  useEffect(() => {
    getRoleDetails();
  }, [formik.values.factoryID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUSERSCREEN');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    getProvinces();
    GetAllGroups();
  }

  async function setForEdit(id) {
    let userDetailsRes = await services.getUserByID(id);
    if (userDetailsRes != null) {
      setValues({
        userTypeID: userDetailsRes.userTypeID,
        groupID: userDetailsRes.groupID,
        factoryID: userDetailsRes.factoryID,
        roleID: userDetailsRes.roleID,
        userName: userDetailsRes.userName,
        firstName: userDetailsRes.firstName,
        secondName: userDetailsRes.secondName,
        lastName: userDetailsRes.lastName,
        nIC: userDetailsRes.nic,
        address1: userDetailsRes.address1,
        address2: userDetailsRes.address2,
        mobileNumber: userDetailsRes.mobileNumber,
        province: userDetailsRes.province,
        district: userDetailsRes.district,
        city: userDetailsRes.city,
        isLock: userDetailsRes.isLock,
        isActive: userDetailsRes.isActive
      })


    }
  }
  async function GetAllGroups() {
    var res = await services.GetAllGroups()
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetFactoriesByGroupID() {
    var res = await services.GetFactoriesByGroupID(formik.values.groupID)
    if (res != null) {
      setFactory(res);
    }
  }

  async function getProvinces() {
    const res = await locationServices.getAllProvice();
    if (res != null) {
      setProvinces(res);
    }
  }

  async function getRoleDetails() {
    try {
      const res = await userServices.getUserRole(formik.values.groupID, formik.values.factoryID);
      if (res != null) {
        setRoles(res);
      }
    } catch (error) {

    }
  }

  async function getDistrictFromProvince(data) {
    try {
      const res = await locationServices.getDistritcsByProvince(parseInt(data));
      if (res != null) {
        setDistrict(res);
      }
    } catch (error) {

    }
  }

  async function getCitiesFromFilter(province, district) {
    try {
      const res = await locationServices.getCitiesbyDistrict(parseInt(province), parseInt(district));
      if (res != null) {
        setCity(res);
      }
    } catch (error) {
    }
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <FormikProvider value={formik}>
        <ToastContainer
          position="bottom-right"
          pauseOnHover
        />
        <CommonPageHeader path="/dashboard/user/" btname="Back" pageName={pageProps.pageheadername} />
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={4}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                select
                fullWidth
                size="small"
                label="Group *"
                value={formik.values.groupID}
                onChange={formik.handleChange}
                {...getFieldProps('groupID')}
                error={Boolean(touched.groupID && errors.groupID)}
                helperText={touched.groupID && errors.groupID}
                InputProps={{
                  readOnly: !permissionList.isGroupFilterEnabled
                }}
              >
                <MenuItem key={0} value={0}> Select Group</MenuItem>
                {group.map((option) => (
                  option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                    {option.groupName}
                  </MenuItem> : null
                ))}
              </TextField>
              <TextField
                select
                fullWidth
                size="small"
                label="Operation Entity *"
                value={formik.values.factoryID}
                onChange={formik.factoryID}

                {...getFieldProps('factoryID')}
                error={Boolean(touched.factoryID && errors.factoryID)}
                helperText={touched.factoryID && errors.factoryID}
                InputProps={{
                  readOnly: !permissionList.isFactoryFilterEnabled
                }}
              >
                <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                {factory.map((option) => (
                  option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                    {option.factoryName}
                  </MenuItem> : null
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                label="User Type *"
                value={formik.values.userTypeID}
                onChange={formik.handleChange}
                {...getFieldProps('userTypeID')}
                error={Boolean(touched.userTypeID && errors.userTypeID)}
                helperText={touched.userTypeID && errors.userTypeID}
              >
                <MenuItem key={0} value={0}> Select User Type</MenuItem>
                <MenuItem key={1} value={1}> System Admin</MenuItem>
                <MenuItem key={2} value={2}> Agent</MenuItem>
                <MenuItem key={3} value={3}> Other</MenuItem>
                <MenuItem key={4} value={4}> Finance Admin</MenuItem>
              </TextField>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                select
                size="small"
                label="Role Type *"
                value={formik.values.roleID}
                onChange={formik.handleChange}
                {...getFieldProps('roleID')}
                error={Boolean(touched.roleID && errors.roleID)}
                helperText={touched.roleID && errors.roleID}
              >
                <MenuItem key={0} value={0}> Select Role</MenuItem>
                {roles.map((option) => (
                  <MenuItem key={option.roleID} value={option.roleID}>
                    {option.roleName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                size="small"
                label="First name *"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('firstName')}
                error={Boolean(touched.firstName && errors.firstName)}
                helperText={touched.firstName && errors.firstName}
              />
              <TextField
                fullWidth
                size="small"
                label="Second name *"
                value={formik.values.secondName}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('secondName')}
                error={Boolean(touched.secondName && errors.secondName)}
                helperText={touched.secondName && errors.secondName}
              />
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                size="small"
                label="Last name"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('lastName')}
                error={Boolean(touched.lastName && errors.lastName)}
                helperText={touched.lastName && errors.lastName}
              />
              <TextField
                fullWidth
                size="small"
                label="User name *"
                value={formik.values.userName}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('userName')}
                error={Boolean(touched.userName && errors.userName)}
                helperText={touched.userName && errors.userName}
                InputProps={{
                  readOnly: pageProps.isEdit == true ? true : false
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="NIC"
                value={formik.values.nIC}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('nIC')}
                error={Boolean(touched.nIC && errors.nIC)}
                helperText={touched.nIC && errors.nIC}
              />
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} width={325} spacing={2}>
              <TextField
                fullWidth
                size="small"
                label="Mobile Number *"
                value={formik.values.mobileNumber}
                onChange={formik.handleChange}
                onKeyDown={handleKeyDown}
                {...getFieldProps('mobileNumber')}
                error={Boolean(touched.mobileNumber && errors.mobileNumber)}
                helperText={touched.mobileNumber && errors.mobileNumber}
              />
            </Stack>
            <br />
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                select
                size="small"
                label="Province *"
                value={formik.values.province}
                onChange={formik.handleChange}
                {...getFieldProps('province')}
                error={Boolean(touched.province && errors.province)}
                helperText={touched.province && errors.province}
              >
                <MenuItem key={0} value={0}> Select Province</MenuItem>
                {provinces.map((option) => (
                  <MenuItem key={option.provinceID} value={option.provinceID}>
                    {option.provinceName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                label="District *"
                value={formik.values.district}
                onChange={formik.handleChange}
                {...getFieldProps('district')}
                error={Boolean(touched.district && errors.district)}
                helperText={touched.district && errors.district}
              >
                <MenuItem key={0} value={0}> Select District</MenuItem>
                {district.map((option) => (
                  <MenuItem key={option.districtID} value={option.districtID}>
                    {option.districtName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                label="City *"
                value={formik.values.city}
                onChange={formik.handleChange}
                {...getFieldProps('city')}
                error={Boolean(touched.city && errors.city)}
                helperText={touched.city && errors.city}
              >
                <MenuItem key={0} value={0}> Select City</MenuItem>
                {city.map((option) => (
                  <MenuItem key={option.cityID} value={option.cityID}>
                    {option.cityName}
                  </MenuItem>
                ))}
              </TextField>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                multiline
                size="small"
                value={formik.values.address1}
                onChange={formik.handleChange}
                label="Address 1"
                {...getFieldProps('address1')}
                error={Boolean(touched.address1 && errors.address1)}
                helperText={touched.address1 && errors.address1}
              />
              <TextField
                fullWidth
                multiline
                size="small"
                value={formik.values.address2}
                onChange={formik.handleChange}
                label="Address 2"
                {...getFieldProps('address2')}
                error={Boolean(touched.address2 && errors.address2)}
                helperText={touched.address2 && errors.address2}
              />
            </Stack>
            <br />
            {!pageProps.isEdit ?
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  size="small"
                  hidden={true}
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  label="Password *"
                  {...getFieldProps('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                          <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                />
                <TextField
                  fullWidth
                  size="small"
                  hidden={pageProps.isEdit}
                  autoComplete="current-password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  label="Confirm Password *"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  {...getFieldProps('confirmPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                          <Icon icon={showConfirmPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                />
              </Stack> : null
            }
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <FormControlLabel
                control={
                  <Switch
                    value={formik.values.isActive}
                    checked={formik.values.isActive}
                    {...getFieldProps('isActive')}
                    onClick={formik.handleChange}
                    color='error'
                    name="isActive"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />}
                label="Is Active"
              />
              <FormControlLabel
                control={<Switch
                  value={formik.values.isLock}
                  {...getFieldProps('isLock')}
                  onClick={formik.handleChange}
                  checked={formik.values.isLock}
                  color='error'
                  name="isLock"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />}
                label="Is Lock"
              />
            </Stack>
            <Divider variant="middle" />
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
              <LoadingButton
                size="large"
                type="button"
                color='error'
                variant="outlined"
                onClick={() => formik.resetForm()}
              >
                Clear
              </LoadingButton>
              <LoadingButton
                size="large"
                type="submit"
                color='secondary'
                variant="outlined"
              >
                {pageProps.submitButtonName}
              </LoadingButton>
            </Stack>
          </Stack>
        </Form>
      </FormikProvider>
    </>
  );
}
